var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphoneOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "headset 1",
    clipPath: "url(#clip0_17474_6726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.41016 0 0.179023 4.65234 0.0008125 10L0 12.0781C0 13.6914 1.2793 15 2.85703 15H3.57148C4.35938 15 5 14.3477 5 13.5391V8.33594C5 7.52734 4.35938 6.875 3.57148 6.875H2.85703C2.72902 6.875 2.60922 6.90292 2.48602 6.91984C3.70312 3.96484 6.61328 1.88281 10 1.88242C13.3883 1.88288 16.2969 3.9668 17.5156 6.88633C17.3906 6.90234 17.2695 6.875 17.1445 6.875H16.4301C15.6406 6.875 15 7.52734 15 8.33594V13.5391C15 14.3477 15.6406 15 16.4297 15H17.1441C17.4908 15 17.8187 14.9273 18.1262 14.8117V15.625C18.1262 16.4867 17.4254 17.1875 16.5637 17.1875H12.2395C11.9141 16.6289 11.3164 16.25 10.625 16.25H9.375C8.33984 16.25 7.5 17.0898 7.5 18.125C7.5 19.1602 8.33984 20 9.33984 20H10.625C11.3172 20 11.9152 19.6207 12.2398 19.0625H16.5625C18.4582 19.0625 20 17.5207 20 15.625V10C19.8203 4.65234 15.5898 0 10 0ZM2.85703 8.75H3.125V13.125H2.85703C2.31562 13.125 1.875 12.6211 1.875 12.0781V10C1.875 9.90586 1.88591 9.81445 1.88911 9.72105C1.92695 9.17969 2.34023 8.75 2.85703 8.75ZM17.1445 13.125H16.875V8.75H17.1429C17.6596 8.75 18.0729 9.18125 18.1108 9.72109C18.1133 9.81641 18.125 9.90625 18.125 10V12.0797C18.125 12.6211 17.6836 13.125 17.1445 13.125Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17474_6726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneOutlineIcon);
export default __webpack_public_path__ + "static/media/headphone-outline-icon.802542e61c08db3e0ccb6e13ac0b1ece.svg";
export { ForwardRef as ReactComponent };